/**
 * All switchrtc SDK events
 * @type {Object}
 */
module.exports = {
    CONNECTED: 'connected',
    CONNECTED_TO_SESSION: 'connected-to-session',
    RESTARTING_ICE: 'restarting-ice',
    ERROR: 'error',
    CALL_ENDED: 'call-ended',
    RECONNECTED: 'reconnected',
    REMOTE_DISCONNECT: 'remote-disconnect',
    DISCONNECTED: 'disconnected',
    SERVER_OFFLINE: 'server-offline',
    GOT_REMOTE_STREAM: 'got-remote-stream',
    REMOTE_STREAM_LOST: 'remote-stream-lost',
    GOT_LOCAL_STREAM: 'got-local-stream',
    LOCAL_STREAM_STOPPED: 'local-stream-stopped',
    LOCAL_STREAM_ERROR: 'local-stream-error',
    GOT_SCREEN_SHARE_STREAM: 'got-screen-share-stream',
    SCREEN_SHARE_STOPPED: 'screen-share-stopped',
    SCREEN_SHARE_EXTENSION_ERROR: 'screen-share-extension-error',
    SCREEN_SHARE_DIALOG_CANCELED: 'screen-share-dialog-canceled',
    SESSION_PERMISSIONS_UPDATE: 'session-permissions-update',
    SESSION_INFO_UPDATE: 'session-info-update',
    AUDIO_MUTED: 'audio-muted',
    SESSION_RECORDING_ON: 'session-recording-on',
    SESSION_RECORDING_OFF: 'session-recording-off',
    SESSION_RECORDING_PAUSED: 'session-recording-paused',
    CUSTOM_RECORDER_COMMAND: 'custom-recorder-command',
    REMOTE_SCREEN_SHARE_ADDED: 'remote-screen-share-added',
    REMOTE_SCREEN_SHARE_REMOVED: 'remote-screen-share-removed',
    CHAT_MESSAGE: 'chat-message'
};



// WEBPACK FOOTER //
// ./src/Modules/events.js